import { FC } from 'react';
import { FormQuestion } from '~/lib/Api.types';
import { QuestionType } from '~/lib/Questions';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import AddonAnswer from './Answers/AddOnAnswer';
import ContactInfoAnswer from './Answers/ContactInfoAnswer';
import FileUploadAnswer from './Answers/FileUploadAnswer';
import SignatureAnswer from './Answers/SignatureAnswer';
import CustomQuestionAnswer from './Answers/CustomQuestionAnswer';

type AnswerProps = {
    answer: object | string;
    question: FormQuestion;
    /**
     * The readable form of the answer, worked out server side. Custom
     *  questions rely on it, since nothing but the browser can run their code
     */
    summary?: string;
    answeredAt?: string | null;
};
const FormAnswer: FC<AnswerProps> = ({
    answer,
    question,
    summary,
    answeredAt,
}) => {
    let jsonAnswer = {};
    try {
        jsonAnswer = typeof answer === 'object' ? answer : JSON.parse(answer);
    } catch (e) {
        // ...
    }

    switch (question.type) {
        case QuestionType.AddOn:
            return <AddonAnswer answer={jsonAnswer} />;
        case QuestionType.Signature:
            return <SignatureAnswer answer={jsonAnswer} />;
        case QuestionType.Upload:
            return <FileUploadAnswer answer={jsonAnswer} />;
        case QuestionType.ContactInfo:
            return (
                <ContactInfoAnswer answer={jsonAnswer} question={question} />
            );
        case QuestionType.Custom:
            return (
                <CustomQuestionAnswer
                    answer={jsonAnswer}
                    question={question}
                    summary={summary}
                    answeredAt={answeredAt}
                />
            );
        case QuestionType.VariablePayment: {
            const price = jsonAnswer?.addons?.[0]?.addon?.price;
            return <span>{price != null ? formatCurrency(price) : 'No amount selected'}</span>;
        }
    }

    if (Array.isArray(jsonAnswer)) {
        return <span>{jsonAnswer.join(', ')}</span>;
    }

    const answerIsString = typeof answer === 'string';
    return (
        <span className="leading-tight">
            {!answer && <span className="text-gray-500 italic">No answer</span>}
            {answerIsString && answer}
        </span>
    );
};
export default FormAnswer;
